import { uuid } from './uuid';

/**
 * Generates a UUID without any dashes.
 */
export const cleanUuid = () => uuid().replace(/-/g, '');
